var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormula = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4611_40288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3438 9H12.3438L11.3438 10.9485L10.3438 9H9.34375L10.7963 11.5L9.34375 14H10.3438L11.3438 12.1005L12.3438 14H13.3438L11.8927 11.5L13.3438 9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 3.00001V2.00001H7.3004C7.05055 1.99891 6.80942 2.09183 6.62492 2.26031C6.44041 2.42878 6.32601 2.66049 6.30445 2.90941L5.97805 6.50001H3.84375V7.50001H5.8871L5.3871 13H2.84375V14H5.3871C5.63695 14.0011 5.87808 13.9082 6.06258 13.7397C6.24709 13.5712 6.36149 13.3395 6.38305 13.0906L6.89135 7.50001H9.34375V6.50001H6.9822L7.3004 3.00001H9.84375Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4611_40288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.34375)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormula);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/formula.175815949522795a942bc63c67906df2.svg";